<div class="periods-content">
    @if (!hasPeriods) {
        <div class="empty-state">
            <h3>{{ "PROJECTS.ProjectPeriodsEmptyTitle" | translate }}</h3>
            <p>{{ "PROJECTS.ProjectPeriodsEmptyDescription" | translate }}</p>
        </div>
    }

    @if (!hasPeriods || hasTimelineSegments) {
        <div class="timeline-track" (mousemove)="onTimelineHover($event)" (mouseleave)="clearHoveredSplit()">
            <div class="timeline-ruler">
                @for (hour of hourMarkers; track hour) {
                    <div class="timeline-ruler__cell">{{ formatHour(hour) }}</div>
                }
            </div>

            @if (hoveredSplit; as split) {
                <div class="timeline-hover-layer">
                    <div class="timeline-hover-split" [style.left.%]="split.left">
                        <div class="timeline-hover-split__label">{{ split.label }}</div>
                    </div>
                </div>
            }

            <div class="timeline-body">
                <div class="timeline-grid">
                    @for (hour of hourMarkers; track hour) {
                        <div class="timeline-grid__cell"></div>
                    }
                </div>

                @for (segment of timelineSegments; track segment.key) {
                    <div
                        class="timeline-segment timeline-segment--tone-{{ segment.toneIndex % 10 }}"
                        [class.timeline-segment--virtual]="segment.isVirtual"
                        [style.left.%]="segment.left"
                        [style.width.%]="segment.width"
                        (click)="onSegmentClick(segment, $event)"
                    >
                        <div class="timeline-segment__content">
                            <span class="timeline-segment__name">{{ segment.period.name }}</span>
                            <span class="timeline-segment__time">
                                {{ formatSegmentTime(segment) }}
                            </span>
                        </div>

                        @if (!segment.isVirtual) {
                            <div class="timeline-segment__actions">
                                <button
                                    type="button"
                                    class="timeline-segment__action timeline-segment__action--delete"
                                    (click)="deletePeriod(segment.period, $event)"
                                    [attr.aria-label]="'Delete period'"
                                >
                                    <mat-icon>delete_outline</mat-icon>
                                </button>

                                <button
                                    type="button"
                                    class="timeline-segment__action timeline-segment__action--edit"
                                    (click)="editPeriod(segment.period, $event)"
                                    [attr.aria-label]="'Edit period'"
                                >
                                    <mat-icon>edit</mat-icon>
                                </button>
                            </div>
                        }
                    </div>
                }
            </div>
        </div>
    }

    @if (validationMessage) {
        <div class="timeline-warning">
            <mat-icon>warning_amber</mat-icon>
            <span>{{ validationMessage }}</span>
        </div>
    }

    @if (hasPeriods) {
        <div class="periods-table-card">
            <div class="periods-table-wrap">
                <table class="periods-table">
                    <thead>
                        <tr>
                            <th>Period</th>
                            <th>Intervals</th>
                            <th class="periods-table__actions-column">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (period of listedPeriods; track period.name) {
                            <tr>
                                <td class="periods-table__name">{{ period.name }}</td>
                                <td>{{ getDisplayIntervals(period).join(", ") }}</td>
                                <td class="periods-table__actions">
                                    <button mat-icon-button type="button" (click)="editPeriod(period, $event)" aria-label="edit period">
                                        <mat-icon>edit</mat-icon>
                                    </button>
                                    <button mat-icon-button type="button" (click)="deletePeriod(period, $event)" aria-label="delete period">
                                        <mat-icon color="warn">delete_outline</mat-icon>
                                    </button>
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        </div>
    }
</div>
<div class="add-button">
    <button
        mat-fab
        id="add-period-button"
        aria-label="add period"
        (click)="addPeriod()"
        [@animate]="{ value: '*', params: { delay: '300ms', scale: '.2' } }"
    >
        <mat-icon>add_circle_outline</mat-icon>
    </button>
</div>
